var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"我的二维码","visible":_vm.show,"width":"400px"},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.handleClose}},[_c('div',{staticClass:"flex p-8 justify-center"},[_c('vue-qr',{ref:"qrcode",staticClass:"qrcode",attrs:{"margin":0,"size":300,"text":_vm.data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }